var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0831 11.3315C31.4876 6.40204 27.5944 2.51751 22.6642 0.914247C8.95047 -3.52864 -3.53467 8.94653 0.9169 22.666C2.51245 27.5955 6.40558 31.48 11.3358 33.0833C25.0495 37.5341 37.5347 25.051 33.0831 11.3315ZM26.9323 23.9582C26.9323 24.381 26.5892 24.7239 26.1664 24.7239H18.0531H5.77534H5.2169L5.27274 24.1417C5.85511 19.5712 14.2796 11.9457 16.649 10.1191H8.7271C8.2963 10.1191 7.95326 9.77608 7.95326 9.34535H17.9254H17.9334H30.0675L29.3415 10.0632C21.6989 17.4016 18.8827 22.682 18.2685 23.9582H26.9323Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7386 10.1191C21.3078 10.5738 11.4713 20.8554 10.7134 23.9822H11.3676C11.3835 23.9024 11.3356 24.07 11.3676 23.9822C12.2371 21.5334 17.7418 15.3198 20.5978 12.209C21.611 11.1082 22.6002 10.1431 22.6241 10.1191H21.7386Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoText);
export default __webpack_public_path__ + "static/media/logo_noText.a4fbad30b4036a3169a54f31d9f39739.svg";
export { ForwardRef as ReactComponent };